<script lang="ts">
    import { DATA_POINT_STATE } from "../../script/enum";

    export let backColor: string = '';
    export let valList: { temp: number; state: number }[] = [];
</script>

<!-- <div class="envTargetTempList">
    {#each valList as targetPoint}
        <span
            class="envTargetTempLine"
            style={targetPoint.state === DATA_POINT_STATE.fin
                ? "--dtColor: var(--prim);"
                : targetPoint.state === DATA_POINT_STATE.warn
                ? "--dtColor: var(--warn);"
                : ""}
        />
    {/each}
</div> -->

<div class="targetListWrap" style={backColor ? `--usedBack:${backColor};` : ""}>
    {#each valList as trg}
        <span class="targetTypeTemp">{trg.temp}</span>
        <div class="targetTypeWrap">
            <div
                class={trg.state === DATA_POINT_STATE.start
                    ? "nullTarget"
                    : trg.state === DATA_POINT_STATE.fin
                    ? "oneTarget"
                    : trg.state === DATA_POINT_STATE.incongruous
                    ? "twoTarget"
                    : "warnTarget"}
            />
        </div>
    {/each}
</div>

<style>
    .envTargetTempList {
        --dtColor: var(--back_D12);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px 0;
    }
    .envTargetTempLine {
        height: 9px;
        width: 9px;
        border-radius: 50%;
        margin: 0 5px;
        background: var(--dtColor);
    }

    .targetListWrap {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 5px;
        --usedBack: var(--back);
    }
    .targetTypeTemp {
        font-size: 15px;
        font-weight: 400;
        color: var(--prim_D2);
        color: var(--back_D18);
    }
    .targetTypeWrap {
        height: 15px;
        width: 15px;
        --targetTypeWrapBackground: #0296ff1a;
        /* border: solid 1px var(--prim); */
        border-radius: 5px;
        padding: 4px;
        margin: 0 8px 0 4px;
    }
    .targetTypeWrap > * {
        height: 100%;
        width: 100%;
    }
    .nullTarget {
        clip-path: polygon(0 45%, 100% 35%, 100% 55%, 0 65%);
        /* clip-path: polygon(0 35%, 100% 45%, 100% 65%, 0 55%); */
        background: var(--back_D12);
    }
    .oneTarget {
        /* clip-path: polygon(35% 0, 55% 0, 65% 100%, 45% 100%); */
        clip-path: polygon(65% 0, 45% 0, 35% 100%, 55% 100%);
        background: var(--prim);
    }
    .twoTarget {
        position: relative;
        background: var(--warn);
        clip-path: circle(45% at 50% 50%);
    }
    /*  .twoTarget::before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
        clip-path: circle(25% at 50% 50%);
        
        background: var(--back);
    } */
    /* background: var(--targetTypeWrapBackground); */
    .twoTarget::after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        clip-path: circle(25% at 50% 50%);
        /* background: var(--colorBackThis); */
        background: var(--busedBackack);
    }
    .warnTarget {
        position: relative;
        background: var(--warn);
        clip-path: polygon(50% 0%, 100% 95%, 50% 100%, 0 95%);
    }
    .warnTarget:after {
        content: "";
        background: var(--usedBack);
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        clip-path: polygon(45% 33%, 55% 33%, 55% 75%, 45% 75%);
    }
    .warnTarget::before {
        content: "";
        background: var(--usedBack);
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
        clip-path: polygon(45% 70%, 55% 70%, 55% 85%, 45% 785%);
    }
</style>
